export const getUserId = () => {
  const local = localStorage.getItem("userId");
  const session = sessionStorage.getItem("userId");

  const id = local || session;
  return id ? Number(id) : null;
};
